/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_UnderlineInputs */

const en_tables_custom_properties_underline = /** @type {(inputs: Tables_Custom_Properties_UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Underline`)
};

const de_tables_custom_properties_underline = /** @type {(inputs: Tables_Custom_Properties_UnderlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstrichen`)
};

/**
* | output |
* | --- |
* | "Properties Underline" |
*
* @param {Tables_Custom_Properties_UnderlineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_underline = /** @type {((inputs?: Tables_Custom_Properties_UnderlineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_UnderlineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_underline(inputs)
	return de_tables_custom_properties_underline(inputs)
});